import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, InjectionToken, Injector, Type } from '@angular/core';

export interface SidebarInput<C> {
	component: Type<C>;
	injector?: Injector;
}

export const SIDEBAR_INPUT = new InjectionToken<SidebarInput<Component>>('sidebarComponent');

/**
 * Sidebar component die een custom component mee krijgt en de sidebar met animaties in- en uitschuift.
 */
@Component({
	selector: 'app-sidebar-component',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule],
	host: {
		'animate.enter': 'sidebar-entering',
		'animate.leave': 'sidebar-leaving',
	},
})
export class SidebarComponent {
	readonly sidebarInput = inject(SIDEBAR_INPUT);
}
